/**
 * renders children or '--' based on condition
 * - if condition is true and children exist, renders children
 * - otherwise renders '--'
 */
const EmptyRender = ({ children, condition }: { children?: React.ReactNode; condition?: boolean }) => {
  if (!children || condition !== true) {
    return '--';
  }

  return children;
};

export default EmptyRender;
